import { api } from "../../api"
import { CalendarSettingsViewModelById, makeCalendarSettingsViewModelById } from "./calendar-settings"
import { CalendarSettingsId, CalendarSettingsIdInput, makeCalendarSettingsSearchParams } from "./calendar-settings-id"
import { CalendarSettingsResponse } from "./calendar-settings-response"

const apiEndpoints = {
  calendarSettings: "/calendar-settings",
}

export const calendarSettingsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCalendarSettings: builder.query<
      CalendarSettingsViewModelById,
      CalendarSettingsId[] | CalendarSettingsIdInput[] | void
    >({
      query: (ids?: CalendarSettingsId[] | CalendarSettingsIdInput[]) => ({
        method: "GET",
        url: apiEndpoints.calendarSettings,
        params: makeCalendarSettingsSearchParams(ids),
      }),
      transformResponse: (response: CalendarSettingsResponse) => makeCalendarSettingsViewModelById(response),
    }),
  }),
})

export const { useGetCalendarSettingsQuery, useLazyGetCalendarSettingsQuery } = calendarSettingsApi
